import { Input } from '@orobix/orobix-fe-components'
import { useField, useFormikContext } from 'formik'

export interface SearchUuidProps {
  fieldName: string
  setTrainingSearched: React.Dispatch<React.SetStateAction<boolean>>
}

type E = React.ChangeEvent<HTMLInputElement>

const SearchUuid = ({ fieldName, setTrainingSearched }: SearchUuidProps) => {
  const { isSubmitting } = useFormikContext()
  const [field, meta, helpers] = useField(fieldName)

  const { name, value } = field
  const { error, touched } = meta
  const { setValue, setTouched } = helpers

  return (
    <Input
      name={name}
      id={name}
      label="uuid"
      type="text"
      value={value}
      onChange={(e: E) => {
        setTrainingSearched(false)
        setValue(e.target.value)
      }}
      onBlur={() => setTouched(true)}
      disabled={isSubmitting}
      error={!!(error && touched)}
      errorMessage={error}
      maxLength={50}
    />
  )
}

export default SearchUuid
